export default __webpack_public_path__ + "static/media/about_img1.e37185c5.png";